import { render, staticRenderFns } from "./HeaderClientDetail.vue?vue&type=template&id=5c672260&scoped=true"
import script from "./HeaderClientDetail.vue?vue&type=script&lang=js"
export * from "./HeaderClientDetail.vue?vue&type=script&lang=js"
import style0 from "./HeaderClientDetail.vue?vue&type=style&index=0&id=5c672260&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c672260",
  null
  
)

export default component.exports